import { error } from 'jquery';
import * as Types from '../../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
      case Types.REQUEST_ACCESS_LIST:
        return {
          ...state,
          accessRequestList: action.data.data,
        }
        case Types.REQUEST_ACCESS_LIST_ERROR:
          return {
            ...state,
            accessRequestList: action.error,
          }
      case Types.ALL_COUNTRY_LIST:
        return {
          ...state,
          allCountries: action.data.data,
        }
      case Types.ALL_COUNTRY_LIST_FAILED:
        return {
          ...state,
          allCountryError: action.error,
        }
      case Types.PORTAL_COUNTRY_LIST:
        return {
          ...state,
          portalCountryList: action.data.data,
        }
      case Types.PORTAL_COUNTRIES_FAILED:
        return {
          ...state,
          countryListError: action.error,
        }
      case Types.GET_REGION_LIST:
        return {
          ...state,
          regionList: action.data.data,
        }
      case Types.REGION_LIST_ERROR:
        return {
          ...state,
          regionListError: action.error,
        }
        case Types.SET_OPEN_REQUEST_ACCESS: {
          return {
              ...state,
              isRequestAccessOpen: action.data,
          }
      }
      case Types.GROUP_DATA: {
        return {
            ...state,
            portalGroupList: action.data,
        }
      }
      case Types.GROUP_ERR: {
        return {
            ...state,
            portalGroupListError: action.error,
        }
      }
    default:
        return state;
    }
};